module.exports = __webpack_public_path__ + "img/line-child1.ef1cff50.png";